import { render, staticRenderFns } from "./EditorGallery.vue?vue&type=template&id=025fb7ec&"
import script from "./EditorGallery.vue?vue&type=script&lang=js&"
export * from "./EditorGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports